import { useCallback, useEffect, useRef, useState } from "react";

const useCounter = (seconds: number, interval?: number) => {
  const intervalRef = useRef<any>(null);
  const secondsToMilseconds = seconds * 1000;

  const [counter, setCounter] = useState(secondsToMilseconds);
  const minuteText =
    Math.floor(counter / (60 * 1000)).toString().length === 1
      ? `0${Math.floor(counter / (60 * 1000)).toString()}`
      : Math.floor(counter / (60 * 1000)).toString();
  const secondText =
    Math.floor((counter % (60 * 1000)) / 1000).toString().length === 1
      ? `0${Math.floor((counter % (60 * 1000)) / 1000).toString()}`
      : Math.floor((counter % (60 * 1000)) / 1000).toString();

  const counterInterval = interval || 1000;

  const startCounter = useCallback(() => {
    if (intervalRef.current !== null) return;
    intervalRef.current = setInterval(() => {
      setCounter((counter) => counter - counterInterval);
    }, counterInterval);
  }, [counter]);

  const stopCounter = useCallback(() => {
    if (intervalRef.current === null) return;
    clearInterval(intervalRef.current);
    intervalRef.current = null;
  }, []);
  const resetCounter = () => {
    setCounter(secondsToMilseconds);
    stopCounter();
    intervalRef.current = setInterval(() => {
      setCounter((counter) => counter - counterInterval);
    }, counterInterval);
  };
  useEffect(() => {
    if (counter <= 0) stopCounter();
  }, [counter]);
  return {
    counter,
    startCounter,
    stopCounter,
    minuteText,
    secondText,
    resetCounter,
  };
};
export default useCounter;
